import React, { useContext } from 'react';
import './chapters.scss';
import Chapter1 from './Chapter1';
import Chapter2 from './Chapter2';
import Chapter3 from './Chapter3';
import Chapter4 from './Chapter4';
import Infographics from '../Infographics/Infographics';
import InlinePhotos from '../InlinePhotos/InlinePhotos';
import { WidthContext } from '../../WidthContext';
import InfographicHead from '../Infographics/InfographicHead';
import { lang } from '../lang';

function Chapters() {
  const { viewSize } = useContext(WidthContext);
  const data = lang.chapter;
  const { href, copy, url, copy2 } = lang.cta;

  return (
    <section className="chapters">
      <InlinePhotos index={1} />
      <Chapter1 data={data[0]} />
      <InlinePhotos index={2} />
      <Chapter2 data={data[1]} />
      <Infographics index={0} />
      <InlinePhotos index={3} />
      <Chapter3 data={data[2]} />
      {viewSize === 'small' && <InfographicHead index={1} />}
      <Infographics index={1} />
      <InlinePhotos index={4} />
      <Chapter4 data={data[3]} />
      <a className="chapters__cta" href={href} target="_blank" rel="noreferrer">
        <span className="chapters__cta__text">
          {copy} <span className="chapters__cta__url">{url}</span> {copy2}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="27"
          viewBox="0 0 17 27"
          fill="none"
        >
          <path d="M2 25.7538L14 13.8769L2 2" stroke="white" strokeWidth="3" />
        </svg>
      </a>
    </section>
  );
}

export default Chapters;
